import React from 'react'
import { Modal } from 'react-bootstrap';
import ChangeCommentFormComponent from './ChangeCommentFormComponent';

interface ChangeCommentDialogProps {
    show: boolean;
    onClose: () => void;
    reservationId: string;
}

const ChangeCommentDialog: React.FC<ChangeCommentDialogProps> = ({ show, onClose, reservationId }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Change Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ChangeCommentFormComponent reservationId={reservationId} onClose={onClose} />
            </Modal.Body>
        </Modal>
    )
}

export default ChangeCommentDialog